export default "__VITE_ASSET__vstnmp_x__"